"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Heading = _interopRequireDefault(require("../Heading"));

var _Tags = _interopRequireDefault(require("../Tags"));

var _OutlineButton = _interopRequireDefault(require("../OutlineButton"));

var _Box = _interopRequireDefault(require("../Box"));

var _Badge = _interopRequireDefault(require("../Badge"));

var _StripeContentContainer = _interopRequireDefault(require("../StripeContentContainer"));

var _styledSystem = require("styled-system");

var _primitives = require("./primitives");

var _excluded = ["variant", "titleFontSize"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Bundle = function Bundle(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$titleFontSize = _ref.titleFontSize,
      titleFontSize = _ref$titleFontSize === void 0 ? 24 : _ref$titleFontSize,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var paddingX = [4, null, 6];

  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.badgeProps && /*#__PURE__*/_react["default"].createElement(_Badge["default"], (0, _extends2["default"])({
    type: "corner",
    borderRadius: "6px 0px",
    style: {
      transform: 'translate(-2px, -2px)'
    }
  }, props.badgeProps)), /*#__PURE__*/_react["default"].createElement(_primitives.StyledBody, {
    px: paddingX,
    py: 4
  }, /*#__PURE__*/_react["default"].createElement(_Heading["default"].h3, {
    fontSize: titleFontSize
  }, props.titleIcon ? props.titleIcon : '', props.title), props.bodyComponent ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.subtext && /*#__PURE__*/_react["default"].createElement(_Tags["default"], null, props.subtext.map(function (tag, key) {
    return /*#__PURE__*/_react["default"].createElement(_Tags["default"].Tag, {
      key: key,
      fontSize: "xs"
    }, tag);
  })), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    pt: 2,
    justifyContent: "space-between",
    flexDirection: ['column', null, 'row']
  }, /*#__PURE__*/_react["default"].createElement(_StripeContentContainer["default"], {
    variant: variant
  }, props.bodyComponent), props.buttonText && /*#__PURE__*/_react["default"].createElement(_Box["default"], null, /*#__PURE__*/_react["default"].createElement(_OutlineButton["default"], {
    variant: variant,
    mt: [4, null, 0],
    width: ['100%', null, 'auto'],
    lineHeight: 1.15
  }, props.buttonText)))) : props.placeholder), props.footerComponent && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    px: paddingX,
    py: 3,
    "data-testid": "footer-box",
    borderTop: 2,
    borderColor: "greys.alto"
  }, props.footerComponent));

  return props.onClick || props.href ? /*#__PURE__*/_react["default"].createElement(_primitives.StyledNakedButton, {
    onClick: props.onClick,
    buttonVariant: variant,
    "data-testid": 'bundle',
    href: props.href,
    target: props.target
  }, content) : /*#__PURE__*/_react["default"].createElement(_primitives.StyledBundleBox, {
    "data-testid": 'bundle-box'
  }, content);
};

Bundle.propTypes = _objectSpread(_objectSpread({}, _styledSystem.variant.propTypes), {}, {
  title: _propTypes["default"].string.isRequired,
  badgeProps: _propTypes["default"].shape(_propTypes["default"].Badge),
  titleIcon: _propTypes["default"].node,
  titleFontSize: _propTypes["default"].number,
  subtext: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
  bodyComponent: _propTypes["default"].node,
  placeholder: _propTypes["default"].node,
  buttonText: _propTypes["default"].string,
  footerComponent: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  href: _propTypes["default"].string,
  target: _propTypes["default"].string
});
var _default = Bundle;
exports["default"] = _default;